import { useMutation, useQueryClient } from "@tanstack/react-query";

/** Park (Nurture with a revisit date) and resume, the two lifecycle moves a prospect page makes. */
export function useProspectActions(companyId: string | undefined) {
  const qc = useQueryClient();
  const done = () => {
    qc.invalidateQueries({ queryKey: ["company", companyId] });
    qc.invalidateQueries({ queryKey: ["/api/prospects"] });
  };
  const post = async (path: string, body?: unknown) => {
    const r = await fetch(`/api/prospects/${companyId}/${path}`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body ?? {}),
    });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error ?? "Failed");
  };
  const park = useMutation({ mutationFn: (input: { revisitOn: string | null; reason: string | null }) => post("park", input), onSuccess: done });
  const resume = useMutation({ mutationFn: () => post("resume"), onSuccess: done });
  return { park, resume };
}
